import { ENV } from '@core/constants/env';
import {
    init,
    browserTracingIntegration,
    replayIntegration,
} from '@sentry/react';

const excludeErrors = [
    '_mfq is not defined',
    "Can't find variable: _mfq",
    "Cannot read properties of undefined (reading 'domInteractive')",
    "Failed to read the 'sessionStorage' property from 'Window': Access is denied for this document.",
    'error_send_reset_password_link: cooldown',
    'ResizeObserver loop completed with undelivered notifications.',
    "Can't find variable: gmo",
];

const sampleErrors: { message: string; percentage: number }[] = [];

export default function initializeSentry() {
    init({
        environment: ENV.MODE,

        // Comment out line below when troubleshooting in local development
        enabled: ENV.MODE !== 'development',

        dsn: 'https://32fb39c4738f8d499f9b33f017cad5b0@o433895.ingest.sentry.io/4506638349631488',
        integrations: [
            browserTracingIntegration(),
            replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
                maxReplayDuration: 10 * 60 * 1000, // 10 minutes
                networkDetailAllowUrls: [
                    'https://graphql-gw-bcf-ng-dev.spotloan.com/v1/graphql',
                    'https://hasura.bcf-ng-qa.us-east-1.spotloan.com/v1/graphql',
                    'https://graphql.spotloan.com/v1/graphql',
                ],
            }),
        ],

        // Performance Monitoring
        tracesSampleRate: 0.1, //  Capture 10% of the transactions
        // Session Replay
        replaysSessionSampleRate: 0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        beforeSend(event) {
            if (
                event.exception &&
                event.exception.values &&
                event.exception.values.length > 0
            ) {
                const exceptionValue = event.exception?.values[0].value;
                if (
                    typeof exceptionValue === 'string' &&
                    excludeErrors.includes(exceptionValue)
                ) {
                    return null;
                }
                for (const sampleError of sampleErrors) {
                    if (
                        typeof exceptionValue === 'string' &&
                        exceptionValue.includes(sampleError.message) &&
                        sampleError.percentage
                    ) {
                        if (Math.random() > sampleError.percentage) {
                            return null;
                        }

                        break;
                    }
                }
            }

            return event;
        },
    });
}
